<template>
  <div class="table-responsive">
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th data-test="vendorOrderListinghead1"
														id="vendorOrderListinghead1">Order Number</th>
          <th data-test="vendorOrderListinghead2"
														id="vendorOrderListinghead2">Product Id</th>
          <th data-test="vendorOrderListinghead3"
														id="vendorOrderListinghead3">Quantity</th>
          <th data-test="vendorOrderListinghead4"
														id="vendorOrderListinghead4">Shipping Method</th>
          <th data-test="vendorOrderListinghead5"
														id="vendorOrderListinghead5">Order Status</th>
          <th data-test="vendorOrderListinghead6"
														id="vendorOrderListinghead6">Payment Status</th>
          <th data-test="vendorOrderListinghead7"
														id="vendorOrderListinghead7">Order Date</th>
          <th data-test="vendorOrderListinghead8"
														id="vendorOrderListinghead8">Shipped Date</th>
          <th data-test="vendorOrderListinghead9"
														id="vendorOrderListinghead9">Delivered Date</th>
          <th data-test="vendorOrderListinghead10"
														id="vendorOrderListinghead10">Delivery Address</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(order, index) in orders"
          :key="index"
        >
          <td :data-test="'vendorOrderListingData1'+index"
														:id="'vendorOrderListingData1'+index">
            {{order.order_number}}
          </td>
          <td :data-test="'vendorOrderListingData2'+index"
														:id="'vendorOrderListingData2'+index">
            {{order.product_id}}
          </td>
          <td :data-test="'vendorOrderListingData3'+index"
														:id="'vendorOrderListingData3'+index">
            {{order.quantity}}
          </td>
          <td :data-test="'vendorOrderListingData4'+index"
														:id="'vendorOrderListingData4'+index">
            {{order.shipping_method}}
          </td>
          <td :data-test="'vendorOrderListingData5'+index"
														:id="'vendorOrderListingData5'+index">
            {{order.order_status}}
          </td>
          <td :data-test="'vendorOrderListingData6'+index"
														:id="'vendorOrderListingData6'+index">
            {{order.payment_status}}
          </td>
          <td :data-test="'vendorOrderListingData7'+index"
														:id="'vendorOrderListingData7'+index">
            {{order.order_date}}
          </td>
          <td :data-test="'vendorOrderListingData8'+index"
														:id="'vendorOrderListingData8'+index">
            {{order.shipped_date}}
          </td>
          <td :data-test="'vendorOrderListingData9'+index"
														:id="'vendorOrderListingData9'+index">
            {{order.delivered_date}}
          </td>
          <td :data-test="'vendorOrderListingData10'+index"
														:id="'vendorOrderListingData10'+index">
            {{order.customer_details.customerAddress.addresslineone}},<br>
            {{order.customer_details.customerAddress.addresslinetwo}},<br>
            {{order.customer_details.customerAddress.place}},<br>
            {{order.customer_details.customerAddress.locality}},<br>
            {{order.customer_details.customerAddress.state}},<br>
            {{order.customer_details.customerAddress.country}}.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { vendorApis } from '@/services/ApiServices/vendorApis'

export default {
	data () {
		return {
			orders: []
		}
	},
	mounted () {
		vendorApis.vendorOrderListInfo()
			.then((res) => {
				this.orders = res.data
			})
	}
}
</script>
